import { v4 as uuidv4 } from 'uuid';

export function ResponsiveLayoutDesktop(props = {}, childrenComponents = []) {
	return {
		componentName: 'ResponsiveLayoutDesktop',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
